import React from "react";
import { BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

export default function History() {
  return (
    <section dir="rtl" className="w-full bg-white dark:bg-neutral-900 py-16 font-sans transition-colors duration-300">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center">
        
        {/* Section Title */}
        <h2 className="text-3xl font-medium text-[#2596be] dark:text-sky-400 mb-10 text-center w-full">
          التاريخ
        </h2>

        {/* History Text (Aligned Right) */}
        <div className="w-full text-neutral-800 dark:text-neutral-200 text-lg md:text-xl leading-relaxed space-y-6 mb-10 font-medium text-right">
          <p>
            تأسس نادي مستقبل المرسى الرياضي سنة 2000، ليحمل على عاتقه حلماً رياضياً كبيراً يمثل مدينة المرسى وأقاليمنا الجنوبية أحسن تمثيل. منذ خطواته الأولى، لم يكن مسار الفريق سهلاً، بل كان مليئاً بالتحديات والصعاب التي اختبرت عزيمة الرجال وصبر الجماهير. لكن بروح القتالية، والإيمان الراسخ بمشروع النادي، استطاع الفريق أن يتجاوز كل العقبات ليتحول من مجرد فكرة إلى كيان رياضي قوي ومنافس شرس.
          </p>
          <p>
            اليوم، يعيش نادي مستقبل المرسى عصره الذهبي ونهضته الحقيقية، متوجاً مجهودات إدارته، لاعبيه، وجماهيره الوفية بصعود تاريخي ومستحق إلى القسم الوطني هواة. هذا الإنجاز لم يكن ليتحقق لولا التسيير الاحترافي والعمل الدؤوب، والذي جعل من النادي نموذجاً يحتذى به في المنطقة.
          </p>
          <p>
            نحن لا نلعب فقط من أجل الفوز في المباريات، بل نلعب لنرفع راية المرسى عالياً، ولنبني مستقبلاً كروياً زاهراً للأجيال القادمة. مسيرتنا مستمرة، وطموحنا لا حدود له.
          </p>
        </div>

        {/* Bottom Button */}
        <Link to="/history" className="relative z-10 flex items-center gap-2 bg-[#2596be] dark:bg-sky-600 text-white px-8 py-3 rounded-lg font-bold text-base hover:bg-[#1e7b9e] dark:hover:bg-sky-500 transition-colors shadow-sm mt-4 w-fit cursor-pointer">
          <BookOpen size={20} />
          التاريخ الكامل
        </Link>
        
      </div>
    </section>
  );
}